import { render, staticRenderFns } from "./AdminAccessLog.vue?vue&type=template&id=be67d66c&scoped=true"
import script from "./AdminAccessLog.vue?vue&type=script&lang=js"
export * from "./AdminAccessLog.vue?vue&type=script&lang=js"
import style0 from "./AdminAccessLog.vue?vue&type=style&index=0&id=be67d66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be67d66c",
  null
  
)

export default component.exports